// import { LoadJson } from '../_fn';

console.log('-- debug --');

switch (global.domain.name) {
  case 'localhost':
  case 't1.besttour.com.tw':
    closeConsole(false);
    break;
  default:
    closeConsole(true);
    // const _url = window.location.origin + '/seminar/json/setting.json';
    // LoadJson(_url)
    // .then(function(res) {
    //   if(global.domain.type === 'dev') {
    //     closeConsole(false);
    //   } else {
    //     closeConsole(res.debug);
    //   }
    // });
    break;
}

function closeConsole(debugClose) {
  if (debugClose) {
    console.clear();
    console.log = function () {};
    console.assert = function () {};
    console.debug = function () {};
    console.dir = function () {};
    console.group = function () {};

    console.warn = function () {
      // 傳入訊息參數為陣列: [...arguments]
    };
    console.error = function () {
      // 傳入訊息參數為陣列: [...arguments]
    };
  }
}
